import { render } from "./kisiCard.vue?vue&type=template&id=1554759c"
import script from "./kisiCard.vue?vue&type=script&lang=js"
export * from "./kisiCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__